"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ConferenceRoomConnectorFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ConferenceRoomConnectorFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.5a1.496 1.496 0 0 0 2.908.5H7a1.5 1.5 0 0 0 1.5-1.5V12H12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8.5V2.5A.5.5 0 0 1 9 2h4.092A1.496 1.496 0 0 0 16 1.5a1.496 1.496 0 0 0-2.908-.5H9a1.5 1.5 0 0 0-1.5 1.5V4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3.5v1.5a.5.5 0 0 1-.5.5H2.908A1.496 1.496 0 0 0 0 14.5Zm14-13Zm-13 13a.5.5 0 0 1 1 0 .5.5 0 0 1-1 0Zm7.001-6.393a1.428 1.428 0 1 0 0-2.856 1.428 1.428 0 0 0 0 2.856ZM8 8.61c-1.429 0-2.5.64-2.5 1.429 0 .394.369.714.714.714h3.572c.345 0 .714-.32.714-.714 0-.79-1.07-1.429-2.5-1.429Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ConferenceRoomConnectorFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ConferenceRoomConnectorFill;
exports["default"] = _default;